if (!window.customElements.get('resizable-option')) {
  window.customElements.define('resizable-option', class ResizableOption extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.id;
      window.resizableOptions = window.resizableOptions || {};
    }

    connectedCallback() {
      window.resizableOptions.needToAddVariant = false;
      setTimeout(() => {
        this.init();
      }, 1000)

    }

    init() {
      this.sizeOptions = document.querySelectorAll('[data-single-option-selector]');
      this.input = document.querySelector('[data-resizable-property-input]');
      this.helperText = document.querySelector('.resizable-option__helper--text');

      this.allOptions = document.querySelectorAll('[data-resizable-option]');
      this.options = document.querySelectorAll('[data-resizable-option]');

      this.productForm = document.querySelector(`#product-form-${this.sectionId}`);
      this.addToCartButton = this.productForm?.querySelector('button[type="submit"]');
      this.variantInput = document.querySelector('[data-resizing-variant-input]');
      this.engraving = document.querySelector('#engravingProduct');
      this.baseVariantInput = this.querySelector('[data-base-variant-resizing-input]'); 

      this.options?.forEach((option) => {
        option.addEventListener('click', () => {
          this.handleOptionSelection(option);
        });
      });

      this.sizeOptions?.forEach((option) => {
        option.addEventListener('click', () => {
          this.handleOptionSelection(null);
        });
      });

      if (this.productForm && !this.productForm.hasAttribute('data-resizable-bound')) {
        this.productForm.setAttribute('data-resizable-bound', 'true');

        this.addToCartButton?.addEventListener('click', (event) => {
          // this.handleFormSubmission(event, true, this.addToCartButton);
        });
      }
    }

    handleFormSubmission(evt, blockEvent, button) {
      console.log(window.resizableOptions.needToAddVariant, this.variantInput);
      if (!window.resizableOptions.needToAddVariant || !this.variantInput) return;
      if (blockEvent) evt.preventDefault();

      this.variantId = this.variantInput.value;

      fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: this.variantId, quantity: 1 }]
        })
      })
        .then((response) => response.json())
        .then(() => {f
          window.resizableOptions.needToAddVariant = false;
          if (blockEvent) button.click();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }

    // Cross function from engraving
    updateVariantInput() {
      if (!this.variantInput) return;
      this.variantInput.setAttribute('name', 'items[2]id');
    }

    handleOptionSelection(option) {
      
      // 1. Reset visual states
      this.allOptions.forEach(opt => opt.classList.remove('active'));
      const blockContainer = this.closest('.product-variant-picker-block');

      if (option) {
        // 2. Highlight resizing option
        option.classList.add('active');
        blockContainer?.classList.add('resizing-active');

        // 3. FORCE BASE VARIANT SYNC
        const parentId = option.dataset.parentId;
        const parentInput = document.getElementById(parentId);
        
        if (parentInput) {
          parentInput.checked = true;
          
          // Update Alpine.js data manually so the form knows the real base size
          const optionIndex = parentInput.dataset.index; // e.g., 'option1'
          const alpineComponent = parentInput.closest('[x-data]');
          
          if (alpineComponent && window.Alpine) {
            // This is the "magic" line that fixes the 5.25 error
            const data = window.Alpine.$data(alpineComponent);
            if (data) {
              data[optionIndex] = parentInput.value;
            }
          }

          // Trigger standard events for Shopify logic
          parentInput.dispatchEvent(new Event('input', { bubbles: true }));
          parentInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // 4. Update resizing properties
        if (this.input) {
          window.resizableOptions.needToAddVariant = true;
          this.input.value = option.dataset.value;
          this.input.removeAttribute('disabled');
          this.helperText?.classList.add('active');
          this.variantInput?.removeAttribute('disabled');
          this.baseVariantInput?.removeAttribute('disabled');
        }
      } else {
        // 5. Normal base size clicked
        blockContainer?.classList.remove('resizing-active');
        window.resizableOptions.needToAddVariant = false;
        this.input?.setAttribute('disabled', 'disabled');
        this.helperText?.classList.remove('active');
        this.variantInput?.setAttribute('disabled', 'disabled');
        this.baseVariantInput?.setAttribute('disabled', 'disabled');
      }
    }
  });
}